// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation RecordPaymentMutation($input: RecordPaymentInput!) {
    recordPayment(input: $input) {
      payment {
        id
        amount
        paymentMethod
        referenceNumber
        paymentDate
        notes
        createdAt
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
